import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { traeResponsablesPlataformas } from './plataformaAPI';
import { queryServer } from '../../app/utils';

export const STATUS = {
    NO_DATA: 'no data',
    SHOWING: 'showing',
    LOADING: 'loading',
    COULDNT_LOAD: 'couldn\'t load',
    NO_ERROR: 0
};

const initialState = {
    results: [],
    status: STATUS.NO_DATA,
    error: STATUS.NO_ERROR
};

export const loadPlataformas = createAsyncThunk(
    'plataforma/loadPlataformas',  
    async (_, { rejectWithValue }) => {
        const response = await queryServer(traeResponsablesPlataformas, null, rejectWithValue);
        const data = await response.json();
        return data;
    }
);

// slice object
export const plataformaSlice = createSlice({
    name: 'plataforma',
    initialState,
    reducers: {
        clearResults: (state) => {
            state.results = [];
            state.status = STATUS.NO_DATA;
            state.error = STATUS.NO_ERROR;
        }
    },
    extraReducers: (builder) => {
        builder
        // loadResponsables
            .addCase(loadPlataformas.pending, (state) => {
                state.results = [];
                state.status = STATUS.LOADING;
                state.error = STATUS.NO_ERROR;
            })
            .addCase(loadPlataformas.fulfilled, (state, action) => {
                state.results = action.payload;
                state.status = STATUS.SHOWING;
                state.error = STATUS.NO_ERROR;
            })
            .addCase(loadPlataformas.rejected, (state) => {
                state.results = [];
                state.status = STATUS.NO_DATA;
                state.error = STATUS.COULDNT_LOAD;
            });
    }
});

// selectors
export const selectPlataforma = (state) => state.plataforma;
export const selectPlataformaResults = (state) => state.plataforma.results;

// exports
export const { 
    clearResults
} = plataformaSlice.actions;
export default plataformaSlice.reducer;